import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false));
    window.scrollTo(0, 0);
  }, [slug]);

  if (post === null) return <div className="pt-40 text-center min-h-screen bg-cream font-serif text-2xl">Loading…</div>;
  if (post === false) return <div className="pt-40 text-center min-h-screen bg-cream"><p className="font-serif text-3xl">Article not found.</p><Link to="/blog" className="link-underline mt-4 inline-block">Back to journal</Link></div>;

  return (
    <div className="pt-28 md:pt-32 pb-24 bg-cream min-h-screen" data-testid="blog-post-page">
      <div className="mx-auto max-w-[820px] px-5 md:px-10">
        <Link to="/blog" className="inline-flex items-center gap-2 font-sans uppercase tracking-[0.2em] text-[11px] text-obsidian/60 hover:text-obsidian mb-10">
          <ArrowLeft className="w-4 h-4" /> The Journal
        </Link>
        <p className="font-sans uppercase tracking-[0.25em] text-[11px] text-amber-deep">{post.category} · {post.read_time}</p>
        <h1 className="mt-4 font-serif text-4xl md:text-6xl leading-[0.98] text-obsidian">{post.title}</h1>
      </div>
      <div className="mx-auto max-w-[1100px] px-5 md:px-10 mt-10">
        <div className="aspect-[16/8] overflow-hidden bg-sand">
          <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
        </div>
      </div>
      <div className="mx-auto max-w-[720px] px-5 md:px-10 mt-12">
        <p className="font-serif text-2xl md:text-3xl leading-relaxed text-obsidian/85 first-letter:font-display first-letter:text-6xl first-letter:float-left first-letter:mr-3 first-letter:text-amber-deep">
          {post.body}
        </p>
      </div>
    </div>
  );
}
